import styled from "styled-components";

export const Label = styled.label`
  display: inline-block;
  color: ${(props) => props.theme.Color};
  font: ${(props) => props.theme.FontLabel};
  line-height: var(--spacing-md);
`;
